import React from 'react';

export default function AboutUsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center overflow-y-auto px-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl p-6 max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6 text-center">About Us</h2>
        <div className="text-gray-700 space-y-6 text-sm leading-relaxed max-h-[65vh] overflow-y-auto pr-2">

          <section>
            <p>
              <strong>Poppyruz</strong> is a passion project created by a solo indie developer who believes in the power of books.
              The app was built to make classic literature more accessible and to provide a personal space for reading your own collections in a beautiful, customizable format.
            </p>
          </section>

          <section>
            <p>
              Our mission is to make reading enjoyable for everyone - whether you’re diving into timeless public domain classics or uploading your own PDFs.
              With personalized themes and clean design, Poppyruz aims to turn your screen into a cozy reading corner.
            </p>
          </section>

          <section>
            <p>
              We operate with a freemium model - where public domain books are free to read, and readers can upgrade for additional features like unlimited uploads.
              All premium payments directly support this indie initiative.
            </p>
          </section>

          <section>
            <p>
              Poppyruz is still growing, and we’re constantly listening to user feedback to improve the experience.
              Thank you for being a part of this journey 💛
            </p>
          </section>

        </div>

        <div className="mt-6 text-center">
          <button
            onClick={onClose}
            className="text-sm text-gray-600 hover:underline"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
